import { useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';
import FJActionHeadshotGenerator from '../../../../redux/action/FJActionHeadshotGenerator';
import FJHeadshotGeneratorRight from '../view/FJHeadshotGeneratorRight';

const FJHeadshotGeneratorRightContainer = () => {
    const dispatch = useDispatch();

    const currentStepIndex = useSelector(state => state.headshotGenerator.currentStepIndex);
    const selectedCategory = useSelector(state => state.headshotGenerator.selectedCategory);
    const tabIndex = useSelector(state => state.headshotGenerator.tabIndex);

    const handlePrevious = useCallback(() => {
        dispatch(FJActionHeadshotGenerator.goPreviousStepAction());
    }, [dispatch]);

    return (
        <FJHeadshotGeneratorRight
            currentStepIndex={currentStepIndex}
            selectedCategory={selectedCategory}
            onPrevious={handlePrevious}
            tabIndex={tabIndex}
        />
    );
};

export default FJHeadshotGeneratorRightContainer;
